export const EMAIL_VALIDATION_REG_EX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const PHONE_VALIDATION_REG_EX = /\+7 \d\d\d \d\d\d-\d\d-\d\d/;

export const CADASTRAL_NUMBER_REG_EX = /^(\d{2}:){2}\d{6,7}:\d{1,}$/;

export const CADASTRAL_NUMBER_CHARS_REX_EX = /^(\d+|:)*$/;
